/*
 * Matching Messages
 *
 * This contains all the text for the Matching container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'app.containers.Matching';

export default defineMessages({
  phoneVerification: {
    defaultMessage: 'Phone Number Verification',
  },
  phoneVerificationAuth: {
    defaultMessage:
      'Your mobile phone number is needed to authenticate your account and also for security and safety purposes. ',
  },
  phoneCountryCode: {
    defaultMessage: 'Country Code',
  },
  phoneNumber: {
    defaultMessage: 'Phone Number',
  },
  phoneGetPin: {
    defaultMessage: 'Get PIN',
  },
  phoneSevenDigitPin: {
    defaultMessage: 'Enter the 7-digit PIN sent to you by SMS.',
  },
  landlineSevenDigitPin: {
    defaultMessage:
      'You will receive a call at {phone}. Enter the 7-digit PIN.',
  },
  somethingWentWrong: {
    defaultMessage: 'Something went wrong!',
  },
  phoneDidntGetCode: {
    defaultMessage: "Didn't get pin?",
  },
  phoneResend: {
    defaultMessage: 'Resend',
  },
  phoneDontHaveMobile: {
    defaultMessage: "I don't have a mobile phone",
  },
  verifyPhoneLater: {
    defaultMessage: 'I want to verify my phone number later.',
  },
  incorrectCode: {
    defaultMessage: 'Incorrect code',
  },
  textedVerification: {
    defaultMessage: 'You have been texted a verification code.',
  },
  calledVerification: {
    defaultMessage: 'You will receive a call with a verification code.',
  },
  phoneNumberVerified: {
    defaultMessage: 'Your phone number has been verified!',
  },
  next: {
    defaultMessage: 'Next',
  },
  previous: {
    defaultMessage: 'Previous',
  },
  verify: {
    defaultMessage: 'Verify',
  },
  reminder: {
    defaultMessage:
      'This is a reminder that a verified number is required for account authentication, security, and safety purposes.',
  },
  loading: {
    defaultMessage: 'Loading...',
  },
});
